const models = { redirect_url: "" };

export default models;
